import { LOCAL_STORAGE_CASE_NUMBER, LOCAL_STORAGE_OIL_SUPPLY } from '../../data/localStorage'

export default {
  // Timers
  currentTimestamp: null,
  fetchedTimestamp: null,
  intervalId: null, // Just to clear on clean up.

  // Data
  loading: true,

  headers: [], // { text: String, value: String, cssClass?: String }[]

  area: null, // Number

  customers: [], // Customer{}[]
  searchText: '', // String
  searchResults: [], // Customer{}[]
  specialString: '[sensor-warning]', // Special string for filtering

  selectedIDs: [], // Number[]

  caseNumberInput: Number(localStorage.getItem(LOCAL_STORAGE_CASE_NUMBER)) || 10,
  oilSupplyInput: Number(localStorage.getItem(LOCAL_STORAGE_OIL_SUPPLY)) || 1000,

  sensorState2Color: {
    none: 'grey',
    ok: 'blue',
    warning: 'red'
  }
}
